// FAQ configuration for Landing page accordion
// Includes title, content, color, and icon for each item

import type { ReactNode } from "react";
import {
  CatIconOutlined,
  DogIconOutlined,
} from "../../shared/Icons/CustomIcons.js";
import { Banknote, HandCoins, Heart, HeartHandshake } from "lucide-react";

export type FaqKey =
  | "whatIsPawseum"
  | "adoptionProcess"
  | "doYouCharge"
  | "favorites"
  | "donations"
  | "howToHelp";

export interface FaqItem {
  id: string;
  /** Key under `landing:faq.items`; title/content are translated at render. */
  i18nKey: FaqKey;
  /**
   * Primary accent color for this item (used for text/border).
   * Hex so we can use it both in Tailwind-compatible classes and inline styles.
   */
  color: string;
  /**
   * Icon rendered next to the question title.
   */
  icon: ReactNode;
}

// Brand-aligned FAQ accent colors (matching Tailwind tokens)
export const FAQ_BLUE = "#3e4db8"; // tailwind: main-blue
export const FAQ_PURPLE = "#78299E"; // tailwind: main-purple

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: "o-que-e-o-pawseum",
    i18nKey: "whatIsPawseum",
    color: FAQ_PURPLE,
    icon: <DogIconOutlined size={22} />,
  },
  {
    id: "quem-trata-adocao",
    i18nKey: "adoptionProcess",
    color: FAQ_BLUE,
    icon: <CatIconOutlined size={22} />,
  },
  {
    id: "cobram-dinheiro",
    i18nKey: "doYouCharge",
    color: FAQ_PURPLE,
    icon: <Banknote size={22} />,
  },
  {
    id: "o-que-sao-favoritos",
    i18nKey: "favorites",
    color: FAQ_BLUE,
    icon: <Heart size={20} />,
  },
  {
    id: "aceitam-doacoes",
    i18nKey: "donations",
    color: FAQ_PURPLE,
    icon: <HandCoins size={22} />,
  },
  {
    id: "como-posso-ajudar",
    i18nKey: "howToHelp",
    color: FAQ_BLUE,
    icon: <HeartHandshake size={22} />,
  },
];
